import { Component, OnInit } from "@angular/core";
import { AllPatient } from "./../../models/patient";
import { VproService } from "./../../service/vpro/vpro.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-patient",
  templateUrl: "./patient.component.html",
  styleUrls: ["./patient.component.css"]
})
export class PatientComponent implements OnInit {
  checkin: any;
  patients: any[];
  cid: any;
  data: any;
  checkout = [];
  today: number = Date.now();
  submitted: boolean;

  constructor(
    private router: Router,
    private checkinService: VproService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.cid = this.route.snapshot.params["cid"];
    this.getCheckinId();
    this.checkoutU();
  }
  checkoutU() {
    try {
      this.submitted = true;
      this.checkinService.getcheckinId(this.cid).subscribe(
        resp => {},
        err => {
          console.log(err);
        }
      );
    } catch (excep) {
      console.log(excep);
    }
  }
  back() {
    this.router.navigate(["appointments/schedule"]);
  }

  getCheckinId() {
    this.checkinService.getcheckinId(this.cid).subscribe(data => {
      this.checkout = data;
      console.log(this.data);
    });
  }

  statuscheck() {
    this.checkinService
      .statuscheckout(this.route.snapshot.params["cid"], this.checkin)
      .subscribe(
        result => {},
        err => {
          console.log(err);
        }
      );
  }
}
